import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Spinner = () => (
  <div className="min-h-screen bg-white flex items-center justify-center">
    <svg className="w-8 h-8 text-indigo-500 animate-spin" fill="none" viewBox="0 0 24 24">
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
    </svg>
  </div>
);

// requireBilling=true (default): needs auth + active/trialing subscription
// requireBilling=false: needs auth only (used for /billing page itself)
const ProtectedRoute = ({ children, requireBilling = true }) => {
  const { currentUser, hasAccess, loading, subscriptionLoading, isSuperUser } = useAuth();

  if (loading) return <Spinner />;
  if (!currentUser) return <Navigate to="/auth" replace />;
  if (requireBilling && subscriptionLoading && !isSuperUser) return <Spinner />;
  if (requireBilling && !hasAccess) return <Navigate to="/billing" replace />;

  return children;
};

export default ProtectedRoute;
